import React from 'react';

function BlogDetailDateSkeleton() {
  return (
    <div
      role="status"
      className="w-full max-w-xs flex flex-col justify-center animate-pulse"
    >
      <div className="h-2.5 xl:h-5 bg-gray-200 rounded-full dark:bg-gray-700 w-full" />
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default BlogDetailDateSkeleton;
